@if (!submitButtonActive()) {
	<mat-progress-bar mode="indeterminate"></mat-progress-bar>
}
<mat-card>
	<mat-card-header>
		<mat-card-title>
			<b i18n="@@contact-heading|Contact page heading">CONTACTO</b>
		</mat-card-title>
	</mat-card-header>
	<mat-card-content class="contact-content">
		<div>
			<p class="section-description" i18n="@@contact-subtitle|Contact page subtitle">
				Estamos trabajando día a día para ofrecerte un mejor servicio, abrimos nuevos canales de
				comunicación para brindarte una atención oportuna según tus necesidades.
			</p>
		</div>
		<form [formGroup]="form" (ngSubmit)="onSubmit()">
			<mat-card>
				<mat-card-content class="contact-form-container">
					<mat-form-field>
						<input matInput i18n-placeholder="@@contact-form-name-placeholder|Name input placeholder" placeholder="Nombre" formControlName="name" maxlength="100" appInputEmptyToNull appInputTrim autocomplete="name">
						@if (form.controls['name'].hasError('required')) {
							<mat-error i18n="@@contact-form-name-required|Name required error">
								Nombre es <strong>requerido</strong>
							</mat-error>
						} @else if (form.controls['name'].hasError('maxlength')) {
							<mat-error i18n="@@contact-form-name-maxlength|Name maxlength error">
								Nombre no debe exceder <strong>100 caracteres</strong>
							</mat-error>
						}
					</mat-form-field>
					<mat-form-field>
						<input matInput i18n-placeholder="@@contact-form-city-placeholder|City input placeholder" placeholder="Ciudad" formControlName="city" maxlength="100" appInputEmptyToNull appInputTrim autocomplete="address-level2">
						@if (form.controls['city'].hasError('required')) {
							<mat-error i18n="@@contact-form-city-required|City required error">
								Ciudad es <strong>requerido</strong>
							</mat-error>
						} @else if (form.controls['city'].hasError('maxlength')) {
							<mat-error i18n="@@contact-form-city-maxlength|City maxlength error">
								Ciudad no debe exceder <strong>100 caracteres</strong>
							</mat-error>
						}
					</mat-form-field>
					<div class="phone-row">
						<mat-form-field class="country-code-field">
							<mat-label i18n="@@contact-form-country-code-label|Country code label">Código</mat-label>
							<mat-select formControlName="countryCode">
								<mat-select-trigger>+{{ selectedCountryCode() }}</mat-select-trigger>
								@for (country of countries; track country.region) {
									<mat-option [value]="country.region">
										{{ country.name }} (+{{ country.code }})
									</mat-option>
								}
							</mat-select>
						</mat-form-field>
						<mat-form-field class="phone-field">
							<input matInput i18n-placeholder="@@contact-form-phone-placeholder|Phone input placeholder" placeholder="Teléfono" formControlName="phone" maxlength="20" appInputEmptyToNull appInputTrim autocomplete="tel-national">
							@if (form.controls['phone'].hasError('required')) {
								<mat-error i18n="@@contact-form-phone-required|Phone required error">
									Teléfono es <strong>requerido</strong>
								</mat-error>
							} @else if (form.controls['phone'].hasError('maxlength')) {
								<mat-error i18n="@@contact-form-phone-maxlength|Phone maxlength error">
									Teléfono no debe exceder <strong>20 caracteres</strong>
								</mat-error>
							}
						</mat-form-field>
					</div>
					<mat-form-field>
						<input matInput type="email" i18n-placeholder="@@contact-form-email-placeholder|Email input placeholder" placeholder="Email" formControlName="email" maxlength="254" autocomplete="email">
						@if (form.controls['email'].hasError('required')) {
							<mat-error i18n="@@contact-form-email-required|Email required error">
								Email es <strong>requerido</strong>
							</mat-error>
						} @else if (form.controls['email'].hasError('email')) {
							<mat-error i18n="@@contact-form-email-invalid|Email format error">
								Email no tiene un <strong>formato válido</strong>
							</mat-error>
						}
					</mat-form-field>
					<mat-form-field>
						<textarea matInput i18n-placeholder="@@contact-form-message-placeholder|Message input placeholder" placeholder="Mensaje" formControlName="message" maxlength="2000" appInputEmptyToNull appInputTrim autocomplete="off"></textarea>
						@if (form.controls['message'].hasError('required')) {
							<mat-error i18n="@@contact-form-message-required|Message required error">
								Mensaje es <strong>requerido</strong>
							</mat-error>
						} @else if (form.controls['message'].hasError('maxlength')) {
							<mat-error i18n="@@contact-form-message-maxlength|Message maxlength error">
								Mensaje no debe exceder <strong>2000 caracteres</strong>
							</mat-error>
						}
					</mat-form-field>
					@if (form.disabled) {
						<h3 i18n="@@contact-form-sent|Message sent confirmation">El mensaje ha sido enviado</h3>
					}
				</mat-card-content>
				<mat-card-actions>
					<button mat-raised-button type="submit" [disabled]="!submitButtonActive() || form.disabled" i18n="@@contact-form-send-button|Send button">Enviar</button>
				</mat-card-actions>
			</mat-card>
		</form>
		@for (office of offices; track office.city) {
			<mat-card>
				<mat-card-content>
					@defer (on viewport) {
						<iframe [src]="office.embedUrl" i18n-title="@@contact-office-map-title|Accessible title of the embedded map iframe for an office" title="Mapa de {{ office.city }}" width="100%" height="450px" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
					} @placeholder {
						<div style="width:100%;height:450px;"></div>
					}
					<br>
					<br>
					<p><a [href]="office.mapUrl" target="_blank" class="wrapped">{{ office.line1 }} {{ office.line2 }}</a></p>
					<p>{{ office.city }} - {{ office.country }}</p>
					<p><b i18n="@@contact-store-phone-label|Phone label">Teléfono: </b><a href="{{ office.phone | phoneFormat:'rfc3966' }}">{{ office.phone | phoneFormat }}</a></p>
					<p><b i18n="@@contact-store-whatsapp-label|Whatsapp label">Whatsapp: </b> <a href="https://wa.me/{{ office.phone.replace('+','') }}" target="_blank">{{ office.phone | phoneFormat }}</a></p>
					<h2 i18n="@@contact-store-hours-title|Hours title">Horarios:</h2>
					<p><b i18n="@@contact-store-hours-mon-sat|Monday to Saturday hours label">Lunes a Sábado:</b> {{ office.open_hours }}</p>
					<p><b i18n="@@contact-store-hours-sundays|Sundays hours label">Domingos:</b> {{ office.open_hours_holiday }}</p>
				</mat-card-content>
			</mat-card>
		}
	</mat-card-content>
</mat-card>
